import { type FC } from "react";

import { type MeFragment } from "@app_schema";

export const MenuProfileName: FC<{
  me: MeFragment;
}> = ({ me }) => (
  <div className="truncate text-sm font-semibold">{me.name}</div>
);
